import { render, staticRenderFns } from "./ParameterSaveModal.vue?vue&type=template&id=c8357dc2&slot=items&"
import script from "./ParameterSaveModal.script.js?vue&type=script&lang=js&"
export * from "./ParameterSaveModal.script.js?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports